var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input-number',_vm._g(_vm._b({ref:"input",model:{value:(_vm.myVal),callback:function ($$v) {_vm.myVal=$$v},expression:"myVal"}},'el-input-number',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }